import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhoneInput from "@Shared/components/inputs/phone-input";
import { UPDATE_CO_APPLICANT_ITEM } from "@Broker/@Modules/clients/board/store/board-mutations";
import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { email } from "vuelidate/lib/validators";
const UPDATE_CO_APP = `BoardStore/${UPDATE_CO_APPLICANT_ITEM}`;
import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "CoApplicantCarouselItem",
  components: {
    PhoneInput,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    coApplicant: {
      type: Object,
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  validations: {
    email: {
      email
    }
  },
  computed: {
    data() {
      return {
        givenName: this.givenName,
        familyName: this.familyName,
        phone: this.phone,
        email: this.email,
        id: this.coApplicantId
      };
    },
    givenName: {
      get() {
        const profile = this.profile;
        if (!profile) return "";
        const data = profile.coApplicants[this.index] || {};
        return data.givenName;
      },
      set(value) {
        this.$store.commit(UPDATE_CO_APP, {
          id: this.id,
          index: this.index,
          payload: _objectSpread(_objectSpread({}, this.data), {}, {
            givenName: value
          })
        });
      }
    },
    familyName: {
      get() {
        if (!this.profile) return "";
        const data = this.profile.coApplicants[this.index] || {};
        return data.familyName;
      },
      set(value) {
        this.$store.commit(UPDATE_CO_APP, {
          id: this.id,
          index: this.index,
          payload: _objectSpread(_objectSpread({}, this.data), {}, {
            familyName: value
          })
        });
      }
    },
    email: {
      get() {
        if (!this.profile) return "";
        const data = this.profile.coApplicants[this.index] || {};
        return data.email;
      },
      set(value) {
        this.$store.commit(UPDATE_CO_APP, {
          id: this.id,
          index: this.index,
          payload: _objectSpread(_objectSpread({}, this.data), {}, {
            email: value
          })
        });
      }
    },
    phone: {
      get() {
        if (!this.profile) return "";
        const data = this.profile.coApplicants[this.index] || {};
        return data.phone;
      },
      set(value) {
        this.$store.commit(UPDATE_CO_APP, {
          id: this.id,
          index: this.index,
          payload: _objectSpread(_objectSpread({}, this.data), {}, {
            phone: value
          })
        });
      }
    },
    coApplicantId() {
      if (!this.profile) return "";
      const data = this.profile.coApplicants[this.index] || {};
      return data.id || "";
    }
  }
});